import moneyFormat from "./moneyFormat";
import rateFormat from "./rateFormat";
import removeStrCommas from "./removeStrCommas";

const applyFormat = (values, config, lists, rateId) => {
    // return same values if no config
    if (!config){
        return values; 
    }
    // initialize temp variable
    let temp = values;
    // apply values for all inputs in config
    for (let i = 0; i < config.length; i++) {    
        if (config[i]['format'] == 'id') {
            // find list to get value from 
            let list = lists[config[i]['columnid']]; 
            // get value from list 
            for (let k = 0; k < list.length; k++) {
                if (((list[k]['id'] !== null && list[k]['id'] !== undefined) && 
                (temp[config[i]['columnid']] !== null && temp[config[i]['columnid']] !== undefined)) &&
                (list[k]['id'].toString() === temp[config[i]['columnid']].toString())) {
                    temp[config[i]['columnid']] = list[k]; 
                }
            }
        }
        else if (config[i]['format'] == 'label') {
            // find list to get value from 
            let list = lists[config[i]['columnid']]; 
            // get value from list 
            for (let k = 0; k < list.length; k++) {
                if (list[k]['label'] == temp[config[i]['columnid']]) {
                    temp[config[i]['columnid']] = list[k]; 
                }
            }
        }
        else if (config[i]['format'] == 'money' && temp[config[i]['columnid']]) {
            let money = moneyFormat(removeStrCommas(temp[config[i]['columnid']]));
            temp[config[i]['columnid']] =  money.replace('$', ''); 
        }
        else if (config[i]['format'] == 'rate') {
            temp[config[i]['columnid']] = rateFormat(temp[config[i]['columnid']], rateId);
        }
        else if (config[i]['format'] == 'date') {
            let date = null 
            if (temp[config[i]['columnid']]) {
                date = new Date(temp[config[i]['columnid']]); 
            }
            temp[config[i]['columnid']] = date; 
        }
        else if (config[i]['format'] == 'date_ovr_offset') {
            let date = null 
            if (temp[config[i]['columnid']]) {
                date = new Date(temp[config[i]['columnid']]); 
                date.setHours(date.getHours() + (date.getTimezoneOffset() / 60)); 
            }
            temp[config[i]['columnid']] = date; 
        }
        else if (config[i]['format'] == 'boolean') {
            temp[config[i]['columnid']] = !!temp[config[i]['columnid']];
        }
    }
    // return object 
    return temp;    
}

export default applyFormat; 